var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9996 12.8133C25.9996 16.2576 25.4224 19.0514 24.7101 19.0514C23.9979 19.0514 23.4209 16.2583 23.4209 12.8133C23.4209 9.36829 23.9981 6.5752 24.7101 6.5752C25.4222 6.5752 25.9996 9.36804 25.9996 12.8133Z",
    fill: "#57585A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7099 12.813C22.7099 16.6581 21.0683 19.7764 19.0434 19.7764C17.0185 19.7764 15.377 16.6581 15.377 12.813C15.377 8.96791 17.0182 5.84961 19.0432 5.84961C21.0681 5.84961 22.7096 8.96692 22.7096 12.813",
    fill: "#57585A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6656 12.8137C14.6656 16.8986 11.3825 20.2101 7.33291 20.2101C3.28329 20.2101 0 16.8979 0 12.8137C0 8.72947 3.28304 5.41699 7.33291 5.41699C11.3828 5.41699 14.6656 8.72872 14.6656 12.8137Z",
    fill: "#57585A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.62f04bb21f76f097c2fdd9e60a7a56cc.svg";
export { ForwardRef as ReactComponent };